module.exports = __webpack_public_path__ + "img/ic-no-gift-code.4886869c.svg";